export default __webpack_public_path__ + "553f893bcfbd27ac979309ee8864e81a.svg";